// Product-owner approved English-only content used by the Easy Read variants
// of components otherwise shared with the normal multilingual Journeys.
// Keep this separate from i18next: do not ask professional translators to
// certify draft Easy Read wording or accidentally suppress normal Journey QA.
export const EASY_READ_SHARED_COPY = Object.freeze({
  feedbackQuestion: 'Did this guide help you understand what may happen at hospital?',
  chooseOneAnswer: 'Choose one answer.',
  answerDefinitely: 'Yes, a lot',
  answerALittle: 'Yes, a little',
  answerNoChange: 'Not much',
  answerNotReally: 'No',
  thankYou: 'Thank you for your answer.',
  endOfGuide: 'End of the guide',
  finishedGuide: 'You have finished this guide',
  readAgain: 'You can read this guide again.',
  seeSavedQuestions: 'See your saved questions',
  backToStart: 'Go back to the start',
  answerHelpsImprove: 'Your answer helps us improve this guide.',
  askStaff: 'You can ask staff if you have questions.',
  savedQuestionsAndNotes: 'Read your saved questions and notes.',
  findOutStaff: 'Find out about hospital staff',
  staffCanHelp: 'Learn how hospital staff can help you.',
  goHome: 'Go to the home page',
  backToKyc: 'Go back to Know Your Care.',
  whatHappens: 'What may happen at hospital',
  peopleCanHelp: 'People who can help you',
  peopleCare: 'These people may help with your care.',
  step: 'Step',
  peopleHere: 'People you may meet here',
  meetHere: 'You may meet these people here.',
  questionsAsk: 'Questions you can ask',
  questionSaved: 'Question saved',
  saveQuestion: 'Save this question',
  pleaseRemember: 'Please remember',
  pictureLabel: 'Easy Read picture',
  pictureNeedsReview: 'Picture needs review',
});
